export function buildMessageTemplateSelectOptions(customMessages) {
    const messages = customMessages ?? [];
    if (!messages.length) {
        return [];
    }

    const groups = [];
    const groupByLanguage = new Map();

    messages.forEach((template) => {
        const groupKey = template.language;
        if (!groupByLanguage.has(groupKey)) {
            const group = {
                text: template.language_label || '',
                children: [],
            };
            groupByLanguage.set(groupKey, group);
            groups.push(group);
        }
        groupByLanguage.get(groupKey).children.push({
            id: String(template.id),
            text: template.name,
        });
    });

    return groups;
}

export function findMessageTemplateById(customMessages, templateId) {
    if (templateId == null || templateId === '') {
        return null;
    }
    return (customMessages ?? []).find((item) => String(item.id) === String(templateId));
}

export function applyMessageTemplateToActionValue(template) {
    const patch = {
        subject: template.subject ?? '',
        message: template.whole_message ?? '',
    };
    if (template.attachment_name) {
        patch.attachment = template.attachment_name;
    } else {
        patch.attachment = null;
    }
    return patch;
}
